import { CURRENCY, TIME_ZONE } from '@teo/shared';
import type { Language } from '../i18n';

const LOCALE: Record<Language, string> = { es: 'es-CO', en: 'en-US' };

/** Valores en pesos colombianos (siempre COP, sin decimales); el formato sigue el idioma. */
export function formatMoney(value: number, lang: Language): string {
  return new Intl.NumberFormat(LOCALE[lang], {
    style: 'currency',
    currency: CURRENCY,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value);
}

export function formatNumber(value: number, lang: Language): string {
  return new Intl.NumberFormat(LOCALE[lang], { maximumFractionDigits: 2 }).format(value);
}

/** Fecha y hora en hora de Bogotá, cualquiera sea el idioma o la zona del equipo. */
export function formatDate(value: Date | string, lang: Language, withTime = true): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(LOCALE[lang], {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hour12: false } : {}),
  }).format(date);
}

/** Día contable (AAAA-MM-DD) en Bogotá: una venta a las 20:30 del 18 pertenece al 18, no al 19 (UTC). */
export function bogotaDay(value: Date | string): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}
